module.exports = __webpack_public_path__ + "static/media/books.aae996db.png";